<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 32 32">
    <path
      d="M17.3639 7H8.96029C8.1538 7 7.5 7.64422 7.5 8.43891V19.6787C7.5 20.4734 8.1538 21.1176 8.96029 21.1176H17.3639C18.1704 21.1176 18.8242 20.4734 18.8242 19.6787V8.43891C18.8242 7.64422 18.1704 7 17.3639 7Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M21.0972 10.8687H23.0397C23.8387 10.8687 24.5 11.5067 24.5 12.3076V23.5609C24.5 24.3483 23.8525 24.9998 23.0397 24.9998H14.6223C13.8233 24.9998 13.162 24.3618 13.162 23.5609"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconCopy',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: none;
  flex-shrink: 0;
}
</style>
